import { Edit } from "@/components/admin/edit";
import { SimpleForm } from "@/components/admin/simple-form";
import { TransactionInputs } from "./TransactionInputs";

export const TransactionEdit = () => (
  <Edit mutationMode="pessimistic" redirect="list">
    <SimpleForm className="max-w-3xl">
      <TransactionInputs />
    </SimpleForm>
  </Edit>
);
